module.exports = "/_next/static/images/edgeware-logo-4b4f5f54ee88cea5c6d7866d1276d545.png";